export const NotificationTypeIcon = {
  1: {
    icon: '/static/icons/selective_icon.svg'
  },
  2: {
    icon: '/static/icons/schedule_icon.svg'
  },
  3: {
    icon: '/static/icons/selective_icon.svg'
  },
  4: {
    icon: '/static/icons/selective_icon.svg'
  },
  // 7 = currículo gerado pelo sistema (NotificationType.curriculum na API).
  7: {
    icon: '/static/icons/ic_notification_mail.svg'
  }
};
